module.exports = {"clientId":"4260228710-0vc09ffpllukps8q1r6s7n422itn5fem.apps.googleusercontent.com","apiKey":"AIzaSyAACizeKfU5L2niiRoMsfW023l9GrSTUAM","scope":"https://www.googleapis.com/auth/calendar","discoveryDocs":["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"]}


//////////////////
// WEBPACK FOOTER
// /home/sign/front/shared/apiGoogleconfig.json
// module id = 823
// module chunks = 0